/** MediaMTX LL-HLS returns 500 on stale `_HLS_skip=YES` delta playlists. Keep msn/part blocking. */
export function sanitizeLlHlsPlaylistUrl(url: string): string {
  if (!url.includes("_HLS_skip=")) return url;
  return url
    .replace(/([?&])_HLS_skip=[^&]*/g, "$1")
    .replace(/\?&/, "?")
    .replace(/[?&]$/, "");
}
